import { Button } from '@mantine/core';
import { Eye } from 'react-feather';
import { notifications } from '@mantine/notifications';
import { useNavigate } from 'react-router-dom';

/**
 * Preview button — entry point into the coach Active Session Preview page
 * (MED-873 / Story 2.3c). Renders in the Session Prep agenda header (MED-793).
 *
 * When `cohortId` + `sessionId` are provided, navigates to the preview route.
 * When either is missing (rare — defensive for callers that haven't been
 * updated yet), a notification informs the coach the preview can't open.
 */

export interface PreviewButtonProps {
  cohortId?: string;
  sessionId?: string;
}

export function PreviewButton({ cohortId, sessionId }: PreviewButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!cohortId || !sessionId) {
      notifications.show({
        title: "Couldn't open preview",
        message: 'Session context is missing.',
        color: 'red',
      });
      return;
    }
    navigate(`/coach/cohorts/${cohortId}/sessions/${sessionId}/preview`);
  };

  return (
    <Button
      variant="default"
      size="sm"
      radius="md"
      leftSection={<Eye size={14} />}
      onClick={handleClick}
      data-testid="session-prep-preview-button"
    >
      Preview
    </Button>
  );
}
